module.exports = __webpack_public_path__ + "img/lcicon.b5b58abc.svg";